import { PAGE_ROUTES, Roles } from "../../utils/constants";
import {
  isAnalyticsGet,
  isBroadcastAdd,
  isBroadcastDelete,
  isBroadcastEdit,
  isBroadcastGet,
  isChatGet,
  isCustomActionsGet,
  isIntegrationGet,
  isOrganization,
  isOrganizationalAppGet,
  isProfileGet,
  isTrainAndContentGet,
  isUserManagementGet,
  isUserRoleGet,
} from "../../utils/permissions";

export const getDefaultRoute = () => {
  if (isChatGet) return PAGE_ROUTES.CHAT;
  if (isIntegrationGet) return PAGE_ROUTES.INTEGRATION;
  if (isProfileGet) return PAGE_ROUTES.PROFILE;
  if (isAnalyticsGet) return PAGE_ROUTES.ANALYTICS;
  if (isUserRoleGet) return PAGE_ROUTES.USER_ROLES;
  if (isUserManagementGet) return PAGE_ROUTES.USER_MANAGEMENT;
  if (isTrainAndContentGet) return PAGE_ROUTES.CONTENT;
  if (isCustomActionsGet) return PAGE_ROUTES.CUSTOM;
  if (isOrganizationalAppGet || isOrganization === Roles.SUPER_ADMIN) return PAGE_ROUTES.ORGANIZATION;
  if (isBroadcastAdd) return PAGE_ROUTES.BROADCAST_SEND_MESSAGE;
  if (isBroadcastGet) return PAGE_ROUTES.BROADCAST_ANALYTICS;
  if (isBroadcastAdd || isBroadcastGet) return PAGE_ROUTES.BROADCAST_TEMPLATE;
  if (isBroadcastEdit || isBroadcastDelete) return PAGE_ROUTES.BROADCAST_USER_GROUPS;
  return "*";
};
